"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _checkbox = _interopRequireDefault(require("@kyruus/checkbox"));
var _styles = require("./styles");
var _Location = require("./Location.utils");
const BookableLocation = _ref => {
  let {
    id,
    name,
    disabled,
    isSelected,
    onSelect,
    street1 = '',
    street2 = '',
    suite = '',
    city = '',
    state = '',
    zip = ''
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.BookableLocationContainer, {
    disabled: disabled,
    className: "BookableLocation",
    "data-testid": "ProviderLocations__Location"
  }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    disabled: disabled,
    checked: isSelected,
    name: id,
    label: name,
    hasError: false,
    labelStyles: `
        & > span:last-of-type {
          border: 0;
          clip: rect(0 0 0 0);
          height: auto;
          margin: 0;
          overflow: hidden;
          padding: 0;
          position: absolute;
          white-space: nowrap;
          width: 1px;
        }
        `,
    onChange: () => !disabled && onSelect(id)
  }), /*#__PURE__*/_react.default.createElement("div", {
    itemProp: "address",
    itemScope: true,
    itemType: "http://schema.org/PostalAddress"
  }, /*#__PURE__*/_react.default.createElement(_Location.Name, null, name), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Location.Street, {
    street1: street1,
    street2: street2,
    suite: suite
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Location.City, null, city, Boolean(state || zip) && ', '), /*#__PURE__*/_react.default.createElement(_Location.State, null, state, " "), /*#__PURE__*/_react.default.createElement(_Location.Zip, null, zip))));
};
BookableLocation.propTypes = {
  id: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  isSelected: _propTypes.bool.isRequired,
  onSelect: _propTypes.func.isRequired,
  disabled: _propTypes.bool.isRequired,
  street1: _propTypes.string,
  street2: _propTypes.string,
  suite: _propTypes.string,
  city: _propTypes.string,
  state: _propTypes.string,
  zip: _propTypes.string
};
var _default = exports.default = BookableLocation;
BookableLocation.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BookableLocation",
  "props": {
    "street1": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "street2": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "suite": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "city": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "state": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "zip": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "name": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "isSelected": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "onSelect": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "disabled": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    }
  }
};